module.exports = __webpack_public_path__ + "static/media/pencil.108cf25a.svg";